import Hdr from '../shared/Hdr'
import React from 'react'
import swal from 'sweetalert';
import { useState, useEffect } from 'react';
import { apiPath1, apiPath2 } from "../services/apiConfig";
//import {Link} from 'react-router-dom';
import TopBanner from '../components/TopBanner';
import { motion, AnimatePresence } from "framer-motion";

function ToolCategory() {

  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const user_id = localStorage.getItem('user-id');
  const usrName = localStorage.getItem('userName');
  //const [category_name,setCategoryName]=useState("");
 // const [section_name, setSecName] = useState("");
  const [categoryName, setCategory] = useState("");
 // const [secName, setSectionName] = useState("");
  const [display, setDisplay] = useState(false);
  const [displayUpdate, setDisplayUpdate] = useState(false);
//  const [displaySec, setDisplaysec] = useState('none');
//  const [displayUpdSec, setDisplayUpdsec] = useState('none');
  const [data, setData] = useState([]);
 // const [section, setSection] = useState([]);
  const [categoryID, setCategoryID] = useState('')
//  const [secID, setSecID] = useState('')
//  const [secStat, setSecStat] = useState()

  const [categoryCode, setCategoryCode] = useState()
  const [updCategoryName, setUpdCategoryName] = useState()
  const [updCategoryCode, setUpdCategorycode] = useState()

  const [selectedCategoryCode, setSelectedCategoryCode] = useState('')
  const [selectedCategoryName, setSelectedCategoryName] = useState('')

    const [selectedToolValue, setSelectedToolValue] = useState('0')
  //  const [tooltype, setToolType] = useState()

  //  const [toolTypeList, setToolTypesList] = useState([])
 //   const [tooltype_id, setToolTypeID] = useState("0")


  useEffect(() => {
    getData()
  }, [])

  const containerVariants = {
    hidden: { x: "100vw" }, // Start off-screen to the right
    visible: { x: 0 },   // Slide into view
    exit: { x: "100vw" },  // Slide off-screen to the right when exiting
  };

  const transitionSettings = {
    duration: 0.5,
    type: "tween",
    ease: "easeInOut",
  };

  /* DELETE CATEGORY */

  function deleteOperation(id) {

    if (usrRole === "staff") {
      swal("You are not authorized to delete!");
      return
    }

    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          DeleteCategory(id);
        }
        else {
          swal("Your record is safe!");
        }

      });

  }

  /* final CATAGORY deletion*/
  async function DeleteCategory(props) {

    let result = await fetch(apiPath1 + "ToolCategoryDelete/" + props,
      {
        method: 'DELETE',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    showSwal(result.status, result.msg)

    getData()
  }


  /* FIND CATAGORY RECORD ON THE BASIS OF CATAGORY ID*/

  async function updateOperation(id) {
    let result = await fetch(apiPath1 + "ToolCategory/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();
    setUpdCategoryName(result.data.category_name);
    setUpdCategorycode(result.data.category_code)

    setCategoryID(id);
    openUpdateCategory()
  }

  /* LIST OF ALL TOOL CATAGORY (for initial screen) */

  async function getData() {

    let result = await fetch(apiPath1 + "ToolCategories",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setData(result.data) }
    else { setData([]) }
  }

  function openCategory() {
    setDisplay(true)
  }

  function closeCategory() {
    clearTransaction()
    setDisplay(false)
  }

  function openUpdateCategory() {
    setDisplayUpdate(true)
  }

  function closeUpdateCategory() {
    setDisplayUpdate(false)
  }

  function categoryHandler(e) {
    e.preventDefault()
    setSelectedCategoryName(e.target.value)
    setCategory(e.target.value)
  }

  function CategoryCodeHandler(e) {
    e.preventDefault()
    setSelectedCategoryCode(e.target.value)
    setCategoryCode(e.target.value)
  }


  function toolTypeHandler(e) {
    e.preventDefault()
    setSelectedToolValue(e.target.value)
  //  setToolType(e.target.value)
  }

  function updateCategoryHandler(e) {
    e.preventDefault()
    setUpdCategoryName(e.target.value)
  }

  /* ADDING NEW CATAGORY*/

  async function addCategory() {
    //    alert(categoryName+", "+selectedToolValue)
    let result = await fetch(apiPath1 + "ToolCategoryAdd", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "category_name": categoryName,
        //"category_code": categoryCode
        "tooltype_id": selectedToolValue
      })
    });
    result = await result.json();

    showSwal(result.status, result.msg)

    getData()
   // setCategory('')
    clearTransaction()
  }

  /* MODIFY A CATEGORY,    */

  async function updateCategory() {

    //alert(categoryID+', '+updCategoryCode+', '+updCategoryName)
    let result = await fetch(apiPath1 + "ToolCategoryUpdate", {
      method: 'PATCH',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "id": categoryID,
        //                        "category_code" : updCategoryCode,
        "category_name": updCategoryName
      })
    });

    result = await result.json();

    showSwal(result.status, result.msg)

    closeUpdateCategory();
    getData()
  }


  function clearTransaction() {
    setSelectedCategoryCode('')
    setSelectedCategoryName('')
    setSelectedToolValue('0')
  }


  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success !",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }

  return (

    <div style={{ 'width': '100%', 'height': '100vh', }}>
      <Hdr />
      <TopBanner name={'Tools Category Master'} />

      <div className="row p16 " style={{ 'height': '95%' }}>
        <div className=" c12-l-12 cont__content-parent p4" style={{ 'height': '100%' }}>

          {/* CTA SECTION */}
          <div className="row mb16">
            <div className="c12-l-4">
            </div>
            <div className="c12-l-6"></div>
            <div className="c12-l-2 align-bottom-right">
              <button onClick={openCategory} type="button" name="button"
                className="btn large gradient round">Add New Category</button>
            </div>
          </div>

          {/* DATA TABLE SECTION */}
          <div className="c12-l-12 cont__content p4" style={{ 'height': '88%' }}>
            <table style={{ 'display': 'block' }}>
              <thead className='thead-blue'>
                <tr>
                  {/* <th className="th-border" width="15%">Id</th> */}
                  <th className="th-border left" width="25%">Code</th>
                  <th className="th-border left" width="40%">Name</th>
                  <th className="th-border left" width="35%">Tool Type</th>

                  <th className="th-border" width="30%">Edit</th>

                </tr>
              </thead>
              <tbody >
                {
                  data.map((item, index) =>
                    <tr className="tr-two-color-grey" key={index}>
                      {/*  <td className="center">{item.id}</td> */}
                      <td className="">{item.category_code}</td>
                      <td className="">{item.category_name}</td>
                      <td className="">{item.tooltype_name}</td>
                      <td onClick={() => { updateOperation(item.id) }} className="center"><img src={require('../asset/icons/adm_edit.png')} alt="" /></td>
                    </tr>
                  )
                }
              </tbody>
            </table>
          </div>

        {/* SCREEN FROM ADDING NEW CATAGORY */}

        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {display && (
          <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="newCategory" 
            className="cont__lineitem">
            
            <form className="" action="" method="">
              <div className="row box gradient corner-round-tr">
                <div className="c12-l-11">
                  <h3 className='txt-subtlewhite'>Add Cagtegory</h3>
                </div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeCategory}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32 px16">
                <div className="c12-l-12">
                  <br /><br />

                  
                  <p>Type</p>
                  <select className="small" value={selectedToolValue} onChange={toolTypeHandler}>
                    <option value="0">Select Type</option>
                    <option value="1">Heavy Tool</option>
                    <option value="2">Tool</option>
                    <option value="3">consumable</option>
                  </select>
                  <br />
                
{/*
                  <p>Catagory code</p>
                  <input type="text" value={selectedCategoryCode} className="box small"
                    placeholder="Category Code" onChange={CategoryCodeHandler} />
*/}
                  <p>Name</p>
                  <input type="text" value={selectedCategoryName} className="box small"
                    placeholder="Name of the Category" onChange={categoryHandler} />

                  <br /><br />
                  <button onClick={addCategory} type="button" name="button"
                    className="btn gradient round">Add Category</button>
                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>

        {/* SCREEN FROM MODIFYING CATAGORY */}

        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayUpdate && (
          <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="updateCategory" className="cont__lineitem">
            <form className="" action="" method="">
              <div className="row box gradient corner-round-tr">
                <div className="c12-l-11">
                  <h3 className='txt-subtlewhite'>Update Category</h3>
                </div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeUpdateCategory}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32 px16">
                <div className="c12-l-12">
                  <br /><br />

                  <p>Category Code</p>
                  <input type="text" className="box small"
                    placeholder="Category Code" value={updCategoryCode} />

                  <p>Name</p>
                  <input type="text" className="box small"
                    placeholder="Name of the Category" onChange={updateCategoryHandler}
                    value={updCategoryName} />
                  <br /><br />
                  <button className="btn gradient round large" type="button" onClick={updateCategory}>Update Category</button>
                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>
        </div>
      </div>
    </div>
  );
}

export default ToolCategory;
